module.exports = __webpack_public_path__ + "img/validation-light.51cfbc34.svg";